import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { init, refreshToken } from '../../auth/handleTokens';
import useAuth from '../../auth/useAuth';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';
import TagInputs from './TagInputs';

import {isAndroid} from 'react-device-detect'


const ModalMessage = (props) => {
  console.log('renderizado modalMessage...')
    const [messages, setMessages] = useState([]);
    const [dataLinks, setDataLinks] = useState([]);
    const [day, setDay] = useState('lunes');
    const [time, setTime] = useState('2');
    const [ampm, setAmpm] = useState('pm');
    const [link, setLink] = useState('www.minegocio.com');
    const [viewLink, setViewLink] = useState('www.minegocio.com');
    const [percent, setPercent] = useState('10%');
    const [date, setDate] = useState('20/06/2022');
    const [charactersCount, setCharactersCount] = useState(0);
    const [creditsCount, setCreditsCount] = useState(0);

    const [restartTags, setRestartTags] = useState(false);

    const [sending, setSending] = useState(false);

    const {showNotification} = useContext(NotificationContext);

    const divMessageCreateRef = useRef();
    const divCelphonesRef = useRef();
    const divGroupsRef = useRef();
    const btnClose = useRef();
    const {user} = useAuth();

    useEffect(() => {
        getMessages(parseInt(props.id), props.typeMessage);
        getLinks();
    }, [props.id])
    
    const handleDay = (target) => {
        setDay(target.value);
    }

    useEffect(() =>{
      setCharactersCount(divMessageCreateRef.current.textContent.length);
    }, [day, viewLink, ampm, date, percent, time])

    useEffect(() => {
      const value = charactersCount / 150
      setCreditsCount(Math.ceil(value));
    }, [charactersCount])

    const handleNumTime =  (target) => {
      setTime(target.value);
    }

    const handleAmpm = (target) => {
      setAmpm(target.value);
    }

    const listLinks = dataLinks.map((link) => 
      <option key={link._id}>{link.name + '-'+ link.url_short}</option>
    )

    const getLinks = async() => {
      try {
        const result = await init();
        console.log( result +' continuamos updateContact...')
        if(!result) return window.location.href = '/login';
        const token = window.localStorage.getItem('at');
        const URL = constants.test_host + '/sms/links/list'
        const {data} = await axios.get(URL, {headers: {
          'content-type': 'application/json',
          'authorization': `Bearer ${token}`
        }, withCredentials: true});
        if(data) setDataLinks(data.links);
        
      } catch (error) {
        console.log(error.response.data)
        if(error.response.data.statusCode === 401){
          const result = await refreshToken();
          if(result) getLinks();
          else return window.location.href= '/login';
        }else {
          return window.location.href = '/login';
        }
      }
    }

    const handleLink = (target) => {
      if(target.value !== 'Selecciona') {
        const val = target.value;
        const link_ = val.split('-')[1];
        setViewLink(link_);
        setLink(target.value)
      }else{
        setViewLink('www.minegocio.com');
        setLink(target.value)
      }
    }
    
    const handlePercent = (target) => {
      setPercent(target.value + '%');
    }

    const handleDate = (targetValue) => {
      const day_ = targetValue.split('-')[2];
      const month_ = targetValue.split('-')[1];
      const year_ = targetValue.split('-')[0];
      const date_ = day_ + '/' + month_ + '/' + year_
      setDate(date_);
    }

    const handleMessage = async() => {
      const result = await init()
      console.log( result +' continuamos handleMessage...')
      if(!result) return window.location.href = '/login'
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/sms/sendmessage'

      let celphones = [];
      let groups = [];
      const sms = divMessageCreateRef.current.textContent;
      const arrayCelphones= divCelphonesRef.current.childNodes[1].childNodes
      const arrayGroups= divGroupsRef.current.childNodes[1].childNodes
      const totalCredits = creditsCount;
      console.log('isAndroid ' + isAndroid)
      for (const item of arrayCelphones) {
        if(item.className === "tag-item"){
          let num = item.textContent.replace('x', '');
          celphones.push(num);
        }
      }

      if(isAndroid) {
        console.log(arrayCelphones)
        celphones = arrayCelphones.split(',')
        alert('Es Android...')
        return
      }

      for (const item of arrayGroups) {
        if(item.className === "tag-item"){
          let num = item.textContent.replace('x', '');
          groups.push(num);
        }
      }

      console.log(celphones);
      console.log(groups)
      console.log(sms)

      if(celphones.length === 0 && groups.length === 0) {
        showNotification('failed', 'Debe ingresar los números de teléfono o grupos de contactos.')
        return
      }
      if(sms === '') {
        showNotification('failed', 'El contenido del mensaje no puede ser vacío!');
        return;
      }

      setSending(true);
      setRestartTags(!restartTags);

      await axios.post(URL, {celphones, groups, sms, totalCredits }, {headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`}, withCredentials: true})
      .then(({data}) => {
        console.log(data);
        showNotification('success', data.message)
        setSending(false);
        btnClose.current.click();
      })
      .catch(error => {
        console.log(error)
        console.log(error.response.data);
        showNotification('failed', error.response.data.message);
        setSending(false);
      })
       
    }


    const getMessages = async(idMessage, typeMessage) => {
      const result = await init();
      console.log( result +' continuamos getMessages...')
      if(!result) return window.location.href = '/login'
      const URL = constants.test_host + '/sms/default-messages'
      const {data} = await axios.get(URL, {headers: {'content-type': 'application-json'}, withCredentials: true})

      if(data && typeMessage === 'congratulations'){
        setMessages(data.defaultMessages[typeMessage][idMessage - data.defaultMessages['reminders'].length - 1]);
      }else if(data && typeMessage === 'offers'){
        setMessages(data.defaultMessages[typeMessage][idMessage - data.defaultMessages['reminders'].length - data.defaultMessages['congratulations'].length -1]);
      }else{
        setMessages(data.defaultMessages[typeMessage][idMessage - 1]);
      }
      setCharactersCount(divMessageCreateRef.current.textContent.length);
    }

    const spanItem = messages?.map((item)=>
      item === 'day' ? <span className='day'><strong>{day}</strong></span> : <span>{item}</span> &&
      item === 'time' ? <span className='time'><strong>{time}{ampm}</strong></span> : <span>{item}</span> &&
      item === 'link' ? <span className='link'><strong>{viewLink}</strong></span> : <span>{item}</span> &&
      item === 'percent' ? <span className='percent'><strong>{percent}</strong></span> : <span>{item}</span> &&
      item === 'date' ? <span className='date'><strong>{date}</strong></span> : <span>{item}</span> &&
      typeof(item) !== 'number' ? <span>{item}</span> : ''
    )

    const changeButton = messages?.map((item) =>
      item === 'day' ? <select style={{fontSize: 'smaller', marginLeft: '2px', marginRight: '2px'}} value={day} onChange={(e) => handleDay(e.target)}>
      <option>lunes</option>
      <option>martes</option>
      <option>miércoles</option>
      <option>jueves</option>
      <option>viernes</option>
      <option>sábado</option>
      <option>domingo</option>
      </select>:
      item === 'time' ? <div>
        <select style={{fontSize: 'smaller', marginLeft: '2px', marginRight: '2px'}} value={time} onChange={(e) => handleNumTime(e.target)}>
      <option>1</option>
      <option>2</option>
      <option>3</option>
      <option>4</option>
      <option>5</option>
      <option>6</option>
      <option>7</option>
      <option>8</option>
      <option>9</option>
      <option>10</option>
      <option>11</option>
      <option>12</option>
      </select><select style={{fontSize: 'smaller'}} value={ampm} onChange={(e) => handleAmpm(e.target)}><option>am</option><option>pm</option></select>
      </div> :
      item === 'link' ? <select style={{fontSize: 'smaller', marginLeft: '2px', marginRight: '2px'}} value={link} onChange={(e) => handleLink(e.target)}>
        <option>Selecciona</option>
        {listLinks}
      </select> :
      item === 'percent' ? <input type='number' max={100} min={0} style={{width: '50px', fontSize: 'smaller', marginLeft: '2px', marginRight: '2px'}} onChange={(e) => handlePercent(e.target)} />:
      item === 'date' ? <input onChange={(e) => handleDate(e.target.value)} style={{width: '120px', fontSize: 'smaller', marginLeft: '2px', marginRight: '2px'}} type= 'date'  /> : ''
    )

  return ( 
        <>
          <div className=' container modal-header'>
                  
            <div className='modal-title'>
              <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '7%'}} src="/SMS-APP.png" />
              <h2 style={{fontSize: '20px'}} className="font-weight-bold text-white"> SMS APP</h2>
              <button ref={btnClose} style={{backgroundColor: 'white'}} type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
          </div>
          <div className='modal-body text-center text-color'>
            <h6 className="text-color mb-4" style={{fontSize: '13px'}}>
              Escoge las opciones de tu preferencia, escribe tus números de teléfono o agrega un grupo para enviar tu mensaje de forma masiva.
            </h6>
            
            <div className="form-group bg-white px-2 py-2 mb-2 border-message">
               <div className="row">
                   <div className="col">      
                      <div id='messageCreate' ref={divMessageCreateRef} style={{fontSize: '13px'}}>
                          {user.organization.toUpperCase() + ': '}{spanItem}
                      </div>
                    </div>
                </div>
            </div>
            <div className="row">
                   <div className="col ">
                      <span className='conts'>Caracteres: {charactersCount}</span><span className='conts'>Créditos: {creditsCount}</span>     
                      {changeButton}
                    </div>
              </div>
            
          </div>

          <div className='modal-footer text-center'>
            <div ref={divCelphonesRef} style= {{marginRight: '12px'}}>
              <p style={{fontSize:'10px', paddingRight:'72px', maxHeight: '2px'}}>Números de telefono destino separados por coma</p>
              <TagInputs idUser= {props.id} select={false} restart={restartTags} start={props.start} />
            </div>
          
            <div ref={divGroupsRef}>
            <p style={{fontSize:'10px', paddingTop:'5px', maxHeight: '2px', paddingRight:'200px'}}>Selección de grupos</p>
              <TagInputs idUser= {props.id} display= {'none'} select={true} restart={restartTags} start={props.start}/>
            </div>
            <br />
            {!sending && <button className='btn btn-sm btn-primary' onClick={handleMessage}>Enviar <i class="fas fa-paper-plane"></i></button>}
            {sending && <button class="btn btn-primary" type="button" disabled>
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Enviando...<i class="fas fa-paper-plane"></i>
            </button>}
          </div>
        </>
    
);
}

export default ModalMessage
